<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 17"
    width="17"
    height="17"
    fill="none"
    aria-labelledby="info-filled-icon-title info-filled-icon-desc"
    role="img"
>
    <title id="info-filled-icon-title">Info icon</title>
    <desc id="info-filled-icon-desc">An information icon with an exclamation mark inside a circle.</desc>
    <path
        d="M8.33333 0C3.73333 0 0 3.73333 0 8.33333C0 12.9333 3.73333 16.6667 8.33333 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.33333 0ZM9.16667 12.5H7.5V7.5H9.16667V12.5ZM9.16667 5.83333H7.5V4.16667H9.16667V5.83333Z"
        fill="currentColor"
        class="fill"
    />
</svg>
